module.exports = __webpack_public_path__ + "img/qr-code.31c29cf9.svg";